import type { SVGProps } from 'react';
const SvgIconSecurities = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 1a.75.75 0 0 1 .75.75v1.74A1.5 1.5 0 0 1 10 4.968v6a1.5 1.5 0 0 1-1.25 1.479v1.802a.75.75 0 0 1-1.5 0v-1.802A1.5 1.5 0 0 1 6 10.968v-6A1.5 1.5 0 0 1 7.25 3.49V1.75A.75.75 0 0 1 8 1m.5 3.969h-1v6h1zM3.75 3a.75.75 0 0 0-1.5 0v2.49A1.5 1.5 0 0 0 1 6.968v3a1.5 1.5 0 0 0 1.25 1.479v.802a.75.75 0 0 0 1.5 0v-.802A1.5 1.5 0 0 0 5 9.968v-3A1.5 1.5 0 0 0 3.75 5.49zM2.5 9.969v-3h1v3zM13 2.75a.75.75 0 0 1 .75.75v1.99A1.5 1.5 0 0 1 15 6.968v2a1.5 1.5 0 0 1-1.25 1.479v2.802a.75.75 0 0 1-1.5 0v-2.802A1.5 1.5 0 0 1 11 8.968v-2a1.5 1.5 0 0 1 1.25-1.479V3.5a.75.75 0 0 1 .75-.75m.5 4.219v2h-1v-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconSecurities;
